import rightArrowSvg from './right-arrow-svg';

const utils = {
  rightArrowSvg,
  getCurrencySymbol(currency) {
    if (!currency) {
      return '$';
    }

    const currencySymbols = {
      usd: '$',
      eur: '€',
      gbp: '£',
      cad: 'C$',
      aud: 'A$',
      ils: '₪',
      sek: 'SEK',
      brl: 'R$',
      chf: 'CHF',
      php: '₱',
      nzd: 'NZ$',
      ron: 'RON',
      dkk: 'DKK',
      sgd: 'S$',
      zar: 'ZAR',
      aed: 'AED',
      bsd: 'B$',
      clp: 'CLP$',
      kes: 'KES',
      nok: 'NOK',
      rsd: 'RSD',
      scr: 'SCR',
      try: '₺',
      tzs: 'TZS',
      uah: '₴',
      uyu: 'UYU'
    };

    const symbol = currencySymbols[currency.toLowerCase()] || '';
    if (!symbol) {
      throw new Error('Unknown currency');
    }

    return symbol;
  },

  frequencyLabels: {
    single: 'One-time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly'
  },

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
};

export default utils;
